<template>
  <div class="w-100">
    <router-link
      :to="getLink()"
    >
      <article class="interview-list__item" @mouseleave="$refs['dropdownListItem-' + item.interview.id].hide()">
        <div class="interview-list__item-content">
            <div class="interview-list__column interview-list__column--title">
              <div class="editable-area">
                <p
                  ref="editableTitle"
                  class="mr-1 "
                  :contenteditable="isEditable"
                  @click="enableEditing"
                  @blur="handleBlur"
                  @keydown="handleKeyDown"
                >

                  {{ item.interview.name }}
                </p>
                <i
                  @click="enableEditing"
                  class="icon-edit-two"
                />
              </div>
              <div v-if="!isQuestionPage" class="interview-list__item-type">
                <i :class="interviewTypeIcon"></i>
                <p>{{ interviewTypeResource }}</p>
              </div>
              <div v-else class="interview-list__item-type">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M6.41667 4.08333H9.91667V5.25H6.41667V4.08333ZM6.41667 6.41667H9.91667V7.58333H6.41667V6.41667ZM6.41667 8.75H9.91667V9.91667H6.41667V8.75ZM4.08333 4.08333H5.25V5.25H4.08333V4.08333ZM4.08333 6.41667H5.25V7.58333H4.08333V6.41667ZM4.08333 8.75H5.25V9.91667H4.08333V8.75ZM11.725 1.75H2.275C1.98333 1.75 1.75 1.98333 1.75 2.275V11.725C1.75 11.9583 1.98333 12.25 2.275 12.25H11.725C11.9583 12.25 12.25 11.9583 12.25 11.725V2.275C12.25 1.98333 11.9583 1.75 11.725 1.75ZM11.0833 11.0833H2.91667V2.91667H11.0833V11.0833Z" fill="#878787"/>
                </svg>
                <p>{{ item.interview.interviewQuestions?.length }} {{ resource["questionListQuestionText"]}}</p>
              </div>
            </div>
            <div class="interview-list__column interview-list__column--counts" v-if="!isQuestionPage" :style="countsColumnWidth ? `width:${countsColumnWidth}px` : ''">
              <div class="interview-list__count" :data-header="resource['interviewListHeaderCandidatesText']">
                <div class="interview-list__count-content">
                  <i class="icon-user"></i>
                  <p>{{ item.totalCount }}</p>
                </div>
              </div>
              <div class="interview-list__count" :data-header="resource['interviewListHeaderCompletedTitleText']">
                <div class="interview-list__count-content">
                  <i class="icon-user"></i>
                  <p>{{ item.completedCount }}</p>
                </div>
              </div>
              <div class="interview-list__count" :data-header="resource['interviewListHeaderIncompleteTitleText']">
                <div class="interview-list__count-content">
                  <i class="icon-user"></i>
                  <p>{{ item.notCompletedCount }}</p>
                </div>
              </div>
            </div>
            <div class="interview-list__column interview-list__column--status" :data-header="resource['interviewListHeaderStatusText']">
              <div v-if="isActive"
                  class="interview-list__status published"
                  v-b-tooltip.hover.bottom="{ customClass: 'interview-list-tooltip' }"
                  :title="resource['hrvenue.interviewlist.ModifyDate'] + ' ' + lastModifyDate">
                <i class="icon-tick-rounded"></i>
                <p>{{ resource["interviewListItemPublishedText"]}}</p>
              </div>
              <div v-else class="interview-list__status passive">
                <i class="icon-minus"></i>
                <p>{{ resource["interviewListItemPassiveText"]}}</p>
              </div>
            </div>
          <div class="interview-list__column interview-list__column--analyze" v-if="!isQuestionPage && item.interview.type === 1" :data-header="resource['interviewListHeaderAnalyzeText']">
            <div
              v-if="item.completedCount === 0"
              class="interview-list__analyze"
              v-b-tooltip.hover.bottom="{ customClass: 'interview-list-tooltip' }"
              :title="resource['interviewListItemNoneCompletedTooltipText']"
            >
              <p>{{ resource["interviewListItemNoneCompletedText"]}}</p>
            </div>
            <div
              v-else-if="item.analyzeStatus || item.transcriptionStatus === 1 || item.transcriptionStatus === 2"
              class="interview-list__analyze"
            >
              <div class="interview-list__analyze-content">
                <i
                  class="icon-schedule"
                  v-if="item.analyzeStatus !== 3 && (item.transcriptionStatus === 1 || item.transcriptionStatus === 2 || item.analyzeStatus === 1 || item.analyzeStatus === 2)"
                  />
                <i class="icon-tick-rounded" v-if="item.analyzeStatus === 3" />
                <p v-if="item.analyzeStatus === 3">{{ resource["candidateAnalyzedText"] }}</p>
                <p v-else-if="item.analyzeStatus === 1 || item.analyzeStatus === 2">{{ resource["candidateAnalyzingText"] }}</p>
                <p v-else-if="item.transcriptionStatus === 1 || item.transcriptionStatus === 2">{{ resource["candidateTranscribingText"] }}</p>

              </div>
            </div>
            <div v-else-if="item.completedCount > 0 && !item.analyzeStatus">
              <b-button :id="`analyze-${item.interview.id}`" name="analyzeBtn" @click="analyzeInterviewHandler" :class="`gradient-border-button ${!isActive || analyzeButtonLoading ? 'disabled' : ''}`">
                <i class="icon-awesome-two" width="16" height="16" />
                <span>{{ resource["interviewListItemAnalyzeBtn"]}}</span>
              </b-button>
            </div>
          </div>
          <div class="interview-list__column interview-list__column--analyze" v-if="isQuestionPage">
            <div
              class="interview-list__analyze"
            >
              <p style="color: #333;">{{ creationDate }}</p>
            </div>
          </div>
          <div class="interview-list__column interview-list__column--analyze" v-if="isQuestionPage">
            <div
              class="interview-list__analyze"
            >
              <p style="color: #333;">{{ lastModifyDate }}</p>
            </div>
          </div>
        </div>
        <div class="interview-list__item-actions dropdown-action cursor-pointer" @click="showActionMenuHandler(item.interview.id, $event)">
          <b-dropdown right no-caret :ref="`dropdownListItem-${item.interview.id}`" :id="`dropdownListItemId-${item.interview.id}`">
            <template #button-content>
              <i class="icon-more-vert"></i>
            </template>
            <b-dropdown-item id="makeEditActiveBtn" name="makeEditBtn" @click="editInterview" ><i class="icon-edit-two" />{{resource["hrvenue.interviewlist.edit"]}}</b-dropdown-item>
            <b-dropdown-item id="copyInterviewBtn" name="copyInterviewBtn" @click="copyInterview"><i class="icon-copy" />{{resource["hrvenue.interviewlist.copy"]}}</b-dropdown-item>
            <b-dropdown-item
              v-if="!isQuestionPage"
              id="copyInterviewBtn"
              name="sendReportBtn"
              @click="downloadReport"
              :class="`${!sendReportRight || buttonLoading ? 'disabled' : ''}`"
              v-b-tooltip.hover.bottom="{ customClass: 'interview-list-tooltip', show: !sendReportRight }"
              :title="!sendReportRight ? resource['upgradePlanTooltip'] : ''"
            >
              <i class="icon-forward-mail" />{{resource['sendReportBtnTitle']}}
            </b-dropdown-item>
            <b-dropdown-item v-if="isActive" id="makePassiveBtn" name="makePassiveBtn" @click="makePassive"><i class="icon-passive" />{{resource["hrvenue.interviewlist.passive"]}}</b-dropdown-item>
            <b-dropdown-item v-if="!isActive" id="makePassiveBtn" name="makePassiveBtn" @click="makeActive"><i class="icon-passive" />{{resource["hrvenue.interviewlist.doActive"]}}</b-dropdown-item>
          </b-dropdown>
        </div>
      </article>
    </router-link>
    <div class="interview-list__divider"  v-if="!isLastItem"/>
    <analyze-modal
        v-if="!isQuestionPage"
        :showModal="showModal"
        pageType="interview-list"
        :rights="rights"
        :completedCount="item.completedCount"
        :interviewId="item.interview.id"
        @closeModalHandler="closeModalHandler"
      />
  </div>
</template>

<script>
import ResourceManager from '@/services/resource.service';
import { languageItems } from '@/static/languageItems';
import AnalyzeModal from '@/components/common/AnalyzeModal.vue';
import hrvenueService from '../../../services/hrvenue.service';
import { showNotification } from '../../../static/helpers';

export default {
  name: 'InterviewListCardItem',

  components: {
    AnalyzeModal,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
    pageType: {
      type: String,
      required: true,
    },
    countsColumnWidth: {
      type: Number,
      default: null,
    },
    sendReportRight: {
      type: Boolean,
      required: true,
    },
    rights: {
      type: Array,
      required: true,
    },
    isLastItem: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      buttonLoading: false,
      analyzeButtonLoading: false,

      showModal: false,
      isEditable: false,
      tempTitle: '',
      processedByEnter: false,
      analyzeSelectedLanguage: null,
    };
  },

  computed: {
    isActive() {
      return this.item.interview.isActive;
    },
    lastModifyDate() {
      return this.$moment(
        this.item.interview.lastModifyDate,
      )
        .format('DD.MM.YYYY');
    },
    creationDate() {
      return this.$moment(
        this.item.interview.creationDate,
      )
        .format('DD.MM.YYYY');
    },
    isQuestionPage() {
      return this.pageType === 'question';
    },
    interviewTypeResource() {
      if (this.item.interview.type === 1) {
        return this.resource['interviewList.VideoTypeBadge'];
      }
      if (this.item.interview.type === 3) {
        return this.resource['interviewList.OnetoOneTypeBadge'];
      }
      if (this.item.interview.type === 4) {
        return this.resource['interviewList.PhoneTypeBadge'];
      }
      return this.resource['interviewList.VideoTypeBadge'];
    },
    interviewTypeIcon() {
      if (this.item.interview.type === 1) {
        return 'icon-video';
      }
      if (this.item.interview.type === 3) {
        return 'icon-user';
      }
      if (this.item.interview.type === 4) {
        return 'icon-phone';
      }
      return 'icon-video';
    },
  },

  created() {
    let currentLanguage = null;
    if (typeof ResourceManager.CurrentLang !== 'string') {
      currentLanguage = ResourceManager.CurrentLang.id;
    } else {
      currentLanguage = languageItems.find(
        (item) => item.code === ResourceManager.CurrentLang,
      )?.id;
    }
    this.analyzeSelectedLanguage = currentLanguage;
  },

  methods: {
    setLanguage(language) {
      this.analyzeSelectedLanguage = language.id;
    },
    editInterview() {
      dataLayer.push({
        event: 'ga4_event',
        event_name: 'button_click',
        event_parameters: {
          button_name: 'edit',
        },
        page_type: 'interview-listing',
        site_type: 'interview',
      });
      const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;
      this.isQuestionPage
        ? this.$router.push({
          name: 'QuestionGeneratorEditView',
          params: { interviewId: this.item.interview.id, lang },
        })
        : this.$router.push({
          name: 'InterviewEditView',
          params: { interviewId: this.item.interview.id, lang },
        });
    },

    async downloadReport() {
      if (!this.sendReportRight || this.buttonLoading) {
        return;
      }

      this.buttonLoading = true;
      try {
        const response = await hrvenueService.downloadInterviewReport(this.item.interview.id);
        if (!response.file) {
          return;
        }

        const base64String = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${response?.file}`;
        const downloadLink = document.createElement('a');
        downloadLink.href = base64String;
        downloadLink.download = response.name;
        downloadLink.click();

        dataLayer.push({
          event: 'ga4_event',
          event_name: 'button_click',
          event_parameters: {
            button_name: 'download-report',
          },
          page_type: 'interview-listing',
          site_type: 'interview',
        });
      } catch (error) {
        showNotification(this.resource['label.Error'], error.message);
      }
      this.buttonLoading = false;
    },

    makeActive() {
      this.$emit('updateStatus', this.item.interview, true);
      dataLayer.push({
        event: 'ga4_event',
        event_name: 'make_interview_active_click',
        page_type: 'interview-listing',
        site_type: 'interview',
      });
    },
    copyInterview() {
      this.$emit('copyInterview', this.item.interview.id);
    },
    makePassive() {
      this.$emit('updateStatus', this.item.interview, false);
      dataLayer.push({
        event: 'ga4_event',
        event_name: 'make_interview_passive_click',
        page_type: 'interview-listing',
        site_type: 'interview',
      });
    },
    getLink() {
      const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;
      if (!this.isQuestionPage) {
        return {
          name: 'InterviewDetailView',
          params: {
            interviewId: this.item.interview.id,
            name: this.item.interview.name,
            type: this.item.interview.type,
            transcriptionStatus: this.item.transcriptionStatus,
            analyzeStatus: this.item.analyzeStatus,
            lang,
          },
        };
      }
      if (this.isQuestionPage) {
        return {
          name: 'QuestionGeneratorEditView',
          params: { interviewId: this.item.interview.id, lang },
        };
      }
    },
    showActionMenuHandler(interviewId, event) {
      event.preventDefault();
      this.$refs[`dropdownListItem-${interviewId}`].toggle();
    },
    analyzeInterviewHandler(event) {
      event.preventDefault();
      this.showModal = true;
    },
    closeModalHandler() {
      this.showModal = false;
    },
    routePricing() {
      const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;
      this.$router.push({ name: 'PricingListView', params: { lang } });
    },
    // TODO: bunu sildik ama apideki isteğe göre direk başlatmamız gerekebilir o durumda geri eklenecek
    enableEditing(event) {
      event.preventDefault();
      this.isEditable = true;
      this.$nextTick(() => {
        this.focusAndSelectText();
      });
    },
    focusAndSelectText() {
      const el = this.$refs.editableTitle;
      if (el) {
        el.focus();
        this.tempTitle = this.item.interview.name;

        // Create range and selection
        const range = document.createRange();
        range.selectNodeContents(el);
        range.collapse(false);

        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
      }
    },
    handleBlur(e) {
      if (!this.processedByEnter) {
        this.processTitle(e);
      }
      this.processedByEnter = false;
    },
    handleKeyDown(e) {
      if (e.target.textContent.length > 50
          && e.key !== 'Enter'
          && e.key !== 'Backspace') {
        e.preventDefault();
        return;
      }

      // Handle Enter key
      if (e.key === 'Enter') {
        e.preventDefault();
        this.processedByEnter = true;
        this.processTitle(e);
      }
      if (e.key === 'Escape') {
        this.isEditable = false;
        e.target.textContent = this.tempTitle;
      }
    },
    processTitle(e) {
      this.isEditable = false;

      // Trim and clean the content
      const trimmedContent = e.target.textContent
        .trim()
        .replace(/&nbsp;/g, ' ');

      // Validate title length
      if (trimmedContent.length < 5 || trimmedContent.length > 50) {
        showNotification(this.resource['label.Error'], this.resource.interviewNameLengthError, 'error');
        e.target.textContent = this.tempTitle;
        return;
      }

      // Update title if changed and valid
      if (this.tempTitle !== trimmedContent
          && trimmedContent.length > 4
          && trimmedContent.length < 50) {
        this.setInterviewTitleService(this.item.interview.id, trimmedContent);
      }
    },
    async setInterviewTitleService(id, title) {
      try {
        await hrvenueService.updateInterviewName(id, title).then(() => {
          this.$emit('getInterviews');
          showNotification(
            this.resource['label.Success'],
            this.resource.interviewListItemUpdateTitleSuccessText,
            'success',
          );
        });
      } catch (error) {
        showNotification(this.resource['label.Error'], error.message);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/style/starter.scss";
:deep .dropdown-toggle {
  padding: 0;
  background: transparent;

  i {
    margin-right: 0;
  }
}

::v-deep .dropdown-action {
  .show {
    .btn {
      background: transparent !important;
    }
  }

  @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
    position: absolute;
    top: 32px;
    right: 16px;
  }
}
:deep .dropdown-menu {
  background: #FFFFFF;
  border: 1px solid #E4E4E4;
  margin-right: 6px !important;
  box-shadow: 0px 2px 12px 1px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  padding: 4px 0 !important;
  min-width:auto !important;
  width: 157px !important;
  margin-top: 8px !important;
  margin-right: 0 !important;
  left: 10px !important;

  li {
    &.disabled {
      cursor: not-allowed;
      pointer-events: all;
    }
  }

  @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
    left: -40px !important;
  }
}
:deep .dropdown-item {
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 16px !important;
  color: #353535 !important;
  padding: 6px 8px !important;
  transition: all 0.3s ease-in-out;
  display: flex;
  gap: 8px;
  align-items: center;

  &:hover {
    background: #EEE;
  }

  &.disabled {
    cursor: not-allowed;
    pointer-events: all;
  }
}
.white-tooltip {
  opacity: 1 !important;

  &.bs-tooltip-right {
   ::v-deep .arrow {
      &::before {
        border: 0 !important;
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="9" height="17" viewBox="0 0 9 17" fill="none"><path d="M9 0L9 17L1.53956 9.95403C0.703887 9.16478 0.703888 7.83522 1.53956 7.04597L9 0Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9 15.5L9 17L1.53956 9.95403C0.703887 9.16478 0.703888 7.83522 1.53956 7.04597L9 0L9 1.5L8 2.31994L2.22618 7.77299C1.80835 8.16761 1.80835 8.83239 2.22618 9.22701L8 14.6801L9 15.5Z" fill="%23E5E5E5"/></svg>');
        width: 9px;
        height: 17px;
      }
    }
  }

  &.bs-tooltip-bottom {
    padding: 0 !important;
    top: 15px !important;

    ::v-deep .arrow {
      &::before {
        border: 0 !important;
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="9" height="17" viewBox="0 0 9 17" fill="none"><path d="M9 0L9 17L1.53956 9.95403C0.703887 9.16478 0.703888 7.83522 1.53956 7.04597L9 0Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9 15.5L9 17L1.53956 9.95403C0.703887 9.16478 0.703888 7.83522 1.53956 7.04597L9 0L9 1.5L8 2.31994L2.22618 7.77299C1.80835 8.16761 1.80835 8.83239 2.22618 9.22701L8 14.6801L9 15.5Z" fill="%23E5E5E5"/></svg>');
        width: 9px;
        height: 17px;
        transform: rotate(90deg);
        bottom: 2px;
      }
    }
  }

  ::v-deep .tooltip-inner {
    background: #FFFFFF !important;
    border-radius: 4px !important;
    padding: 12px !important;
    width: 208px !important;
    box-shadow: 0px 2px 6px 0px rgba(176, 186, 197, 0.6);

    text-align: left;
    color: #333;
    /* Typography/Small Text/1 - Regular */
    font-family: Roboto;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
  }
}

.border-button {
  display: flex;
  padding: 6px 16px;
  justify-content: center;
  align-items: center;
  border-radius: 114px;
  border: 1px solid #ff8d06;
  background: transparent !important;
  gap: 8px;
  min-width: 170px;

  color: var(--main-colors-orange, #ff8d06);
  text-align: center;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
  transition: all 0.3s ease-in-out;

  &:hover {
    background: #FF8D06 !important;
    color: #fff !important;

    path {
      fill: #fff !important;
    }
  }

  &--checkbox {
    min-width: fit-content !important;
  }
}

.bg-button {
  display: flex;
  padding: 6px 16px;
  justify-content: center;
  align-items: center;
  border-radius: 114px;
  border: 1px solid #ff8d06;
  background: #ff8d06;
  gap: 8px;
  min-width: 170px;

  color: #fff;
  text-align: center;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
  transition: all 0.3s ease-in-out;

  &:hover {
    background: #FF7415 !important;
  }
}

.interview-list-tooltip {
  opacity: 1 !important;

  &.bs-tooltip-right {
    ::v-deep .arrow {
      &::before {
        border: 0 !important;
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="17" height="9" viewBox="0 0 17 9" fill="none"><path d="M17 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9Z" fill="%23DBF0F9"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9L15.5 9L14.6801 8L9.22701 2.22618C8.83239 1.80835 8.16761 1.80835 7.77299 2.22618L2.31993 8L1.5 9Z" fill="%23B7E1F3"/></svg>');
        width: 17px;
        height: 9px;
      }
    }
  }

  &.bs-tooltip-left {
    ::v-deep .arrow {
      &::before {
        border: 0 !important;
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="17" height="9" viewBox="0 0 17 9" fill="none"><path d="M17 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9Z" fill="%23DBF0F9"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9L15.5 9L14.6801 8L9.22701 2.22618C8.83239 1.80835 8.16761 1.80835 7.77299 2.22618L2.31993 8L1.5 9Z" fill="%23B7E1F3"/></svg>');
        width: 17px;
        height: 9px;
        transform: rotate(180deg);
      }
    }
  }

  &.bs-tooltip-bottom {
    padding: 0 !important;
    top: 10px !important;

    ::v-deep .arrow {
      &::before {
        border: 0 !important;
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="17" height="9" viewBox="0 0 17 9" fill="none"><path d="M17 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 9L0 9L7.04598 1.53956C7.83522 0.703886 9.16478 0.703887 9.95403 1.53956L17 9L15.5 9L14.6801 8L9.22701 2.22618C8.83239 1.80835 8.16761 1.80835 7.77299 2.22618L2.31993 8L1.5 9Z" fill="%23E5E5E5"/></svg>') !important;
        width: 17px;
        height: 9px;
        bottom: 5px;
      }
    }
  }

  ::v-deep .tooltip-inner {
    border: 1px solid var(--Stroke-Colors-Light-Blue-Stroke, #E5E5E5) !important;
    background: var(--Background-Colors-Light-Blue, #FFF) !important;
    border-radius: 4px !important;
    padding: 8px 12px !important;
    width: fit-content !important;
    max-width: fit-content !important;
    box-shadow: 0px 2px 6px 0px rgba(176, 186, 197, 0.6) !important;

    text-align: left;
    color: var(--Text-Colors-Blue-Text, #333) !important;
    /* Typography/Small Text/1 - Regular */
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 150% */
  }
}

.gradient-border-button {
  display: flex;
  padding: 6px 8px;
  justify-content: center;
  align-items: center;
  border-radius: 40px;
  background-color: #fff;

  position: relative;
  z-index: 0;
  border: none;

  i {
    margin: 0;
    color: #FF8D06;
  }

  span {
    color: #333;
    text-align: center;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
    padding: 0 8px;
  }

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: inherit;
    padding: 1px;  /* Kenarlık kalınlığı kadar iç boşluk */

    /* Kenarlık efekti için gradient tanımı */
    background: linear-gradient(var(--border-angle), #FF8D06, #FFC823, #6CF4E2);

    /* Merkezdeki iç kısım (içerik alanı) şeffaf kalsın diye maskeleme */
    -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    mask-composite: exclude;           /* Firefox vs. */
    -webkit-mask-composite: xor;       /* WebKit tabanlı tarayıcılar için */

    z-index: -1;            /* Kenarlık efekti butonun arkasında olsun */
  }

  &:hover {
    &::before {
      animation: gradient-rotate 2s linear infinite;
    }
  }

  &.disabled {
    &::before {
      background: #fff !important;
    }
    cursor: not-allowed;
    border: 1px solid #C3C3C3 !important;

    span,i {
      color: #C3C3C3 !important;
    }
  }
}

@property --border-angle {
  syntax: "<angle>";
  initial-value: 137deg;
  inherits: false;
}

@keyframes gradient-rotate {
  0% { --border-angle: 137deg; }
  100% { --border-angle: 497deg; } /* 137deg + 360deg to complete a full rotation without jumps */
}

::v-deep .new-modal {
  .modal-dialog {
    max-width: 446px;
  }
  .modal-content {
    border-radius: 12px;
  }

  .modal-header {
    border-bottom: 0;
    padding: 12px 12px 0px 12px;

    i {
      font-size: 24px;
      color: #333333;
    }
  }

  .modal-body {
    border-bottom: 0;
    padding: 0px 24px 24px 24px;

    img {
      margin-bottom: 14px;
    }

    h2 {
      color: #353535;
      text-align: center;
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: Roboto;
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: 26px;
      margin-bottom: 8px;
    }

    p {
      color: #858585;
      text-align: center;
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: Roboto;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      margin-bottom: 24px;
    }
  }

  .border-button-create {
    border: 1px solid #ff8d06;
    background: transparent !important;
    display: flex;
    padding: 9px 16px;
    height: auto;
    justify-content: center;
    align-items: center;
    border-radius: 40px;
    transition: all 0.2s ease-in-out;
    flex: 1;

    span {
      color: #ff8d06;
      text-align: center;
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 18px;
      padding: 0 8px;
    }

    i {
      color: #ff8d06;
      font-size: 16px;
      margin-right: 0 !important;
    }

    &.disabled {
      border-color: transparent;
      cursor: auto !important;
    }

    &:hover {
      background: #ff8d06 !important;

      span,
      i {
        color: #fff;
      }
    }
  }

  .bg-button {
    display: flex;
    padding: 9px 16px;
    height: auto;
    justify-content: center;
    align-items: center;
    border-radius: 40px;
    border: 1px solid #ff8d06;
    background: #ff8d06;
    transition: all 0.2s ease-in-out;
    flex:1;

    span {
      color: #fff;
      text-align: center;
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 18px;
      padding: 0 8px;
    }

    i {
      color: #fff;
      font-size: 16px;
      margin-right: 0 !important;
    }

    &.disabled {
      border-color: transparent;
      cursor: auto !important; // bu bozuk tooltip çıkmıyor.
      background:#EEE !important;

      span, i {
        color: #C3C3C3 !important;
      }
    }

    &:hover {
      background: #FF7415;
    }
  }
}

.editable-area {
  display: flex;
  align-items: center;

  i {
    display: none;
  }

  p {
    &[contenteditable="true"] {
      outline: 0px solid transparent;
      background: #DBF0F9;
      text-decoration: none;
    }
  }

  &:hover {
    i {
      display: block;
      cursor: pointer;
    }
    p {
      &[contenteditable] {
        text-decoration: underline;
      }
    }
  }

  &:has(p[contenteditable="true"]) {
    &:hover {
      i {
        display: none;
      }
      p {
        &[contenteditable] {
          text-decoration: none;
        }
      }
    }
  }
}

.interview-list__divider {
  width: calc(100% - 32px);
  height: 1px;
  background: #E5E5E5;
  margin: 0 16px;
}
</style>
